import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MixpanelService } from '@core/services/mixpanel.service';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { Dialog, DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';

@Component({
    selector: 'app-unsaved-changes-modal[scope][closeModal][leavePage]',
    templateUrl: './unsaved-changes-modal.component.html',
    styleUrls: ['./unsaved-changes-modal.component.scss'],
    standalone: true,
    imports: [DialogModule, SharedModule, DividerModule, ButtonModule, TranslateModule, AutoFocusModule],
})
export class UnsavedChangesModalComponent implements AfterViewInit {
    @ViewChild(Dialog) dialog!: Dialog;
    @Input() scope: string = 'process';
    @Input() continueButtonText: string = 'continueEditing';
    @Input() unsavedChangesModalScopeText: string = 'unsavedChangesModalText1';
    @Input() unsavedChangesModalScopeText2: string = 'unsavedChangesModalText2';

    @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
    @Output() leavePage: EventEmitter<void> = new EventEmitter<void>();

    isVisible: boolean = true;

    constructor(private mixpanel: MixpanelService) {}

    ngAfterViewInit() {
        if (this.dialog) {
            const firstBtn = document.getElementById('continue-editing-btn')?.firstChild;
            if (firstBtn) (firstBtn as HTMLButtonElement).focus();
        }
    }

    onHide(): void {
        this.closeModal.emit();
    }

    onLeavePage(): void {
        this.leavePage.emit();
        this.mixpanel.logEvent('leave-without-saving');
    }
}
